import { getDescriptionForPath } from '../../../../config/configEntry';
import { badgeIconFromFlags } from '../../badgeIcon';
import SkillLmProjectSelect from '../../shared/skillLmProjectSelect/SkillLmProjectSelect';
import classes from './SettingsTab.module.css';

const SettingsTab = ({ draft, setDraft, descriptions }) => {
  const setTextField = (key, value) => {
    setDraft(d => ({ ...d, [key]: value }));
  };

  return (
    <div className={classes.List}>
      <div className={classes.Field}>
        <label className={classes.Label} htmlFor="agentId">
          {getDescriptionForPath(descriptions, 'agentId', 'agentId')}
        </label>
        <input
          id="agentId"
          className={classes.TextInput}
          value={draft.agentId ?? ''}
          onChange={e => setTextField('agentId', e.target.value)}
          autoComplete="off"
        />
      </div>
      <SkillLmProjectSelect
        id="skillLmProject"
        label={getDescriptionForPath(descriptions, 'skillLmProject', 'skillLmProject')}
        value={draft.skillLmProject ?? ''}
        onChange={value => setTextField('skillLmProject', value)}
      />
      <div className={classes.Field}>
        <label className={classes.Label} htmlFor="urlPath">
          {getDescriptionForPath(descriptions, 'urlPath', 'urlPath')}
        </label>
        <input
          id="urlPath"
          className={classes.TextInput}
          value={draft.urlPath ?? ''}
          onChange={e => setTextField('urlPath', e.target.value)}
          autoComplete="off"
          placeholder="/unison"
        />
      </div>
      <div className={classes.Field}>
        <label className={classes.CheckboxRow} htmlFor="enableBotMessageCopy">
          <input
            id="enableBotMessageCopy"
            type="checkbox"
            checked={draft.enableBotMessageCopy === true}
            onChange={e =>
              setDraft(d => ({
                ...d,
                enableBotMessageCopy: e.target.checked,
              }))
            }
          />
          <span className={classes.CheckboxLabel}>
            {getDescriptionForPath(descriptions, 'enableBotMessageCopy', 'enableBotMessageCopy')}
          </span>
        </label>
      </div>
      <div className={classes.Field}>
        <label className={classes.CheckboxRow} htmlFor="activeInMyEdu">
          <input
            id="activeInMyEdu"
            type="checkbox"
            checked={draft.activeInMyEdu === true}
            onChange={e =>
              setDraft(d => ({
                ...d,
                activeInMyEdu: e.target.checked,
              }))
            }
          />
          <span className={classes.CheckboxLabel}>
            {getDescriptionForPath(descriptions, 'activeInMyEdu', 'activeInMyEdu')}
          </span>
        </label>
      </div>
      <div className={classes.Field}>
        <label className={classes.CheckboxRow} htmlFor="approvedByPmr">
          <input
            id="approvedByPmr"
            type="checkbox"
            checked={draft.approvedByPmr === true}
            onChange={e => {
              const checked = e.target.checked;
              setDraft(d => {
                const pedagogical = checked ? false : d.pedagogical === true;
                return {
                  ...d,
                  approvedByPmr: checked,
                  pedagogical,
                  icon: badgeIconFromFlags({
                    approvedByPmr: checked,
                    pedagogical,
                  }),
                };
              });
            }}
          />
          <span className={classes.CheckboxLabel}>
            {getDescriptionForPath(descriptions, 'approvedByPmr', 'approvedByPmr')}
          </span>
        </label>
      </div>
      <div className={classes.Field}>
        <label className={classes.CheckboxRow} htmlFor="pedagogical">
          <input
            id="pedagogical"
            type="checkbox"
            checked={draft.pedagogical === true}
            onChange={e => {
              const checked = e.target.checked;
              setDraft(d => {
                const approvedByPmr = checked ? false : d.approvedByPmr === true;
                return {
                  ...d,
                  pedagogical: checked,
                  approvedByPmr,
                  icon: badgeIconFromFlags({
                    approvedByPmr,
                    pedagogical: checked,
                  }),
                };
              });
            }}
          />
          <span className={classes.CheckboxLabel}>
            {getDescriptionForPath(descriptions, 'pedagogical', 'pedagogical')}
          </span>
        </label>
      </div>
    </div>
  );
};

export default SettingsTab;
